import { API_URL } from '../config/constants';
import axios from 'axios';

export interface StatisticsData {
  totalUsers: number;
  totalBooks: number;
  totalCollections: number;
  activeLoans: number;
  totalReviews: number;
  period?: {
    newUsers: number;
    newBooks: number;
    newReviews: number;
  };
}

export interface PopularBook {
  id: number;
  title: string;
  author: string;
  loansCount: number;
}

export interface RecentActivity {
  id: string;
  type: string;
  username: string;
  actionText: string;
  timestamp: string;
}

export interface ReportsData {
  statistics: StatisticsData;
  popularBooks: PopularBook[];
  recentActivity: RecentActivity[];
}

// Funcție pentru a obține statistici generale
export const getStatistics = async (timeRange: string = 'week', token: string) => {
  try {
    const response = await axios.get(`${API_URL}/reports/statistics?timeRange=${timeRange}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Eroare la obținerea statisticilor:', error);
    throw error;
  }
};

// Funcție pentru a obține cărțile populare
export const getPopularBooks = async (limit: number = 5, timeRange: string = 'week', token: string) => {
  try {
    const response = await axios.get(`${API_URL}/reports/popular-books?limit=${limit}&timeRange=${timeRange}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Eroare la obținerea cărților populare:', error);
    throw error;
  }
};

// Funcție pentru a obține activitatea recentă
export const getRecentActivity = async (limit: number = 10, timeRange: string = 'week', token: string) => {
  try {
    const response = await axios.get(`${API_URL}/reports/recent-activity?limit=${limit}&timeRange=${timeRange}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Eroare la obținerea activității recente:', error);
    throw error;
  }
};

// Funcție pentru a obține toate datele pentru rapoarte (endpoint complet)
export const getFullReports = async (timeRange: string = 'week', token: string): Promise<ReportsData> => {
  try {
    const response = await axios.get(`${API_URL}/reports/full?timeRange=${timeRange}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data as ReportsData;
  } catch (error) {
    console.error('Eroare la obținerea raportului complet:', error);
    throw error;
  }
};

export default {
  getStatistics,
  getPopularBooks,
  getRecentActivity,
  getFullReports
}; 